/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SalesAggregate } from './SalesAggregate';
import {
    SalesAggregateFromJSON,
    SalesAggregateFromJSONTyped,
    SalesAggregateToJSON,
} from './SalesAggregate';

/**
 * 
 * @export
 * @interface SalesAggregateResponse
 */
export interface SalesAggregateResponse {
    /**
     * 
     * @type {Array<SalesAggregate>}
     * @memberof SalesAggregateResponse
     */
    data?: Array<SalesAggregate>;
}

/**
 * Check if a given object implements the SalesAggregateResponse interface.
 */
export function instanceOfSalesAggregateResponse(value: object): value is SalesAggregateResponse {
    let isInstance = true;

    return isInstance;
}

export function SalesAggregateResponseFromJSON(json: any): SalesAggregateResponse {
    return SalesAggregateResponseFromJSONTyped(json, false);
}

export function SalesAggregateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesAggregateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(SalesAggregateFromJSON)),
    };
}

export function SalesAggregateResponseToJSON(value?: SalesAggregateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(SalesAggregateToJSON)),
    };
}

